
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("bq09U", function(module, exports) {

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $bW292 = parcelRequire("bW292");

var $iHmVh = parcelRequire("iHmVh");
var $kCmwP = parcelRequire("kCmwP");

var $5BRby = parcelRequire("5BRby");

var $2apnq = parcelRequire("2apnq");

var $49235 = parcelRequire("49235");

var $bAQOb = parcelRequire("bAQOb");

var $geFaw = parcelRequire("geFaw");

var $gd0Sp = parcelRequire("gd0Sp");
(0, $2apnq.provideHealthcheck)();
const $a4ee35ebee2548a7$var$container = document.createElement('div');
$a4ee35ebee2548a7$var$container.id = 'heartbeat';
document.body && document.body.appendChild($a4ee35ebee2548a7$var$container);
const $a4ee35ebee2548a7$var$redirect = ()=>{
    const identity = (0, $bW292.getATLContextDomain)('id');
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
    window.location.assign(redirectUrl);
};
const $a4ee35ebee2548a7$var$HeartbeatComponent = (0, $bAQOb.componentWithFF)('platform.mdt-zora.use-heartbeat-singleton_vzod3', ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCmwP.default), null), ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iHmVh.default), {
        onAuthenticationFailed: $a4ee35ebee2548a7$var$redirect
    }));
(0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: { isAnonymous: isAnonymous } })=>!isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: "heartbeat"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a4ee35ebee2548a7$var$HeartbeatComponent, null))))), $a4ee35ebee2548a7$var$container);

});
parcelRegister("iHmVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcf92c7a99e001c7$export$2e2bcd8739ae039);


var $4Ii5N = parcelRequire("4Ii5N");
const $dcf92c7a99e001c7$var$Heartbeat = ({ endpoint: endpoint = (0, $fc955d7ee56a1262$export$4496080a0271e85d), idleTime: idleTime = (0, $fc955d7ee56a1262$export$af2ff676951003fe), onAuthenticationFailed: onAuthenticationFailed, onBadRequest: onBadRequest })=>{
    (0, $4Ii5N.useHeartbeatOnInterval)(endpoint, idleTime, onAuthenticationFailed, onBadRequest);
    return null;
};
var $dcf92c7a99e001c7$export$2e2bcd8739ae039 = $dcf92c7a99e001c7$var$Heartbeat;

});
const $fc955d7ee56a1262$export$4496080a0271e85d = '/gateway/api/session/heartbeat';
const $fc955d7ee56a1262$export$af2ff676951003fe = 60000;
const $fc955d7ee56a1262$export$f2b2f5ef0b498d26 = 10000;

parcelRegister("4Ii5N", function(module, exports) {

$parcel$export(module.exports, "useHeartbeatOnInterval", () => $5f6662d917336f29$export$27f64c06d2059d33);

var $eUqFw = parcelRequire("eUqFw");

var $lu9mt = parcelRequire("lu9mt");


var $fEpIl = parcelRequire("fEpIl");

var $kG7kP = parcelRequire("kG7kP");
const $5f6662d917336f29$export$27f64c06d2059d33 = (endpoint, idleTime, onAuthenticationFailed, onBadRequest)=>{
    const { nextCallTimestamp: nextCallTimestamp, sessionExpiryTimestamp: sessionExpiryTimestamp, callHeartbeatService: callHeartbeatService, setCallHeartbeatService: setCallHeartbeatService, deactivated: deactivated } = (0, $kG7kP.useHearbeatService)(endpoint, onAuthenticationFailed, onBadRequest);
    const { active: active, tabActive: tabActive } = (0, $fEpIl.useBrowserInteractionTime)(idleTime);
    /**
	 * Initial heartbeat api request
	 */ (0, $eUqFw.useEffect)(()=>{
        setCallHeartbeatService(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * Call heartbeat api when user is idle and the tab is active
	 */ (0, $eUqFw.useEffect)(()=>{
        if (!active && tabActive) setCallHeartbeatService(true);
    }, [
        active,
        tabActive,
        setCallHeartbeatService
    ]);
    (0, $lu9mt.default)(()=>{
        if (callHeartbeatService) return;
        /**
		 * Call heartbeat api when session has expired to initiate redirect.
		 */ if (sessionExpiryTimestamp && sessionExpiryTimestamp.getTime() <= Date.now()) {
            setCallHeartbeatService(true);
            return;
        }
        /**
		 * Call heartbeat api if user is active and nextCallTimestamp is reached.
		 */ if (active && tabActive && nextCallTimestamp && nextCallTimestamp.getTime() <= Date.now()) setCallHeartbeatService(true);
    }, (0, $fc955d7ee56a1262$export$f2b2f5ef0b498d26));
    return {
        nextCallTimestamp: nextCallTimestamp,
        sessionExpiryTimestamp: sessionExpiryTimestamp,
        active: active,
        tabActive: tabActive,
        deactivated: deactivated
    };
};

});
parcelRegister("lu9mt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa43a9552c1c752d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $fa43a9552c1c752d$var$useInterval = function useInterval(callback, delay) {
    var savedCallbackRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(function() {
        savedCallbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $eUqFw.useEffect)(function() {
        var handler = function handler() {
            return savedCallbackRef.current.apply(savedCallbackRef, arguments);
        };
        if (delay !== null) {
            var intervalId = setInterval(handler, delay);
            return function() {
                return clearInterval(intervalId);
            };
        }
    }, [
        delay
    ]);
};
var $fa43a9552c1c752d$export$2e2bcd8739ae039 = $fa43a9552c1c752d$var$useInterval;

});

parcelRegister("fEpIl", function(module, exports) {

$parcel$export(module.exports, "useBrowserInteractionTime", () => $f2fbd4fbd27dbbd1$export$430908eb26d619ec);

var $eUqFw = parcelRequire("eUqFw");

var $cJt2B = parcelRequire("cJt2B");
const $f2fbd4fbd27dbbd1$export$430908eb26d619ec = (threshold)=>{
    const [active, setActive] = (0, $eUqFw.useState)(true);
    const [tabActive, setTabActive] = (0, $eUqFw.useState)(true);
    const activeRef = (0, $eUqFw.useRef)(active);
    activeRef.current = active;
    (0, $eUqFw.useEffect)(()=>{
        let timer;
        timer = new (0, $cJt2B.default)({
            idleTimeoutMs: threshold,
            stopTimerOnTabchange: false,
            browserTabActiveCallbacks: [
                ()=>{
                    setTabActive(true);
                }
            ],
            browserTabInactiveCallbacks: [
                ()=>{
                    setTabActive(false);
                }
            ],
            idleCallbacks: [
                ()=>{
                    if (activeRef.current) setActive(false);
                }
            ],
            activeCallbacks: [
                ()=>{
                    if (!activeRef.current) setActive(true);
                }
            ]
        });
        timer.startTimer();
        return ()=>{
            timer && timer.destroy();
            timer = null;
        };
    }, [
        threshold
    ]);
    return {
        active: active,
        tabActive: tabActive
    };
};

});

parcelRegister("kG7kP", function(module, exports) {

$parcel$export(module.exports, "useHearbeatService", () => $0448ccb197e800dc$export$5cc515bf8ee32bda);

var $eUqFw = parcelRequire("eUqFw");

var $eHfB9 = parcelRequire("eHfB9");
const $0448ccb197e800dc$export$5cc515bf8ee32bda = (endpoint, onAuthenticationFailed, onBadRequest)=>{
    const [nextCallTimestamp, setNextCallTimestamp] = (0, $eUqFw.useState)(undefined);
    const [sessionExpiryTimestamp, setSessionExpiryTimestamp] = (0, $eUqFw.useState)(undefined);
    const [callHeartbeatService, setCallHeartbeatService] = (0, $eUqFw.useState)(false);
    const [deactivated, setDeactivated] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (callHeartbeatService && endpoint && !deactivated) {
            const callAsync = async ()=>{
                try {
                    const response = await (0, $eHfB9.postHeartbeat)(endpoint, onAuthenticationFailed, onBadRequest);
                    setCallHeartbeatService(false);
                    if (response && response.nextCallTimestamp) setNextCallTimestamp(new Date(response.nextCallTimestamp));
                    if (response && response.sessionExpiryTime) setSessionExpiryTimestamp(new Date(response.sessionExpiryTime));
                } catch (error) {
                    setDeactivated(true);
                }
            };
            callAsync();
        }
    }, [
        callHeartbeatService,
        endpoint,
        onAuthenticationFailed,
        onBadRequest,
        deactivated
    ]);
    return {
        nextCallTimestamp: nextCallTimestamp,
        sessionExpiryTimestamp: sessionExpiryTimestamp,
        callHeartbeatService: callHeartbeatService,
        setCallHeartbeatService: setCallHeartbeatService,
        deactivated: deactivated
    };
};

});



parcelRegister("kCmwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1b6c4f4f1e89ca$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eTIsH = parcelRequire("eTIsH");
const $ea1b6c4f4f1e89ca$var$HeartbeatNew = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        const heartbeatService = (0, $eTIsH.getInstance)();
        return ()=>heartbeatService.cleanup();
    }, []);
    return null;
};
var $ea1b6c4f4f1e89ca$export$2e2bcd8739ae039 = $ea1b6c4f4f1e89ca$var$HeartbeatNew;

});

parcelRegister("2apnq", function(module, exports) {

$parcel$export(module.exports, "provideHealthcheck", () => $2d3550a09830cc5e$export$90dcee7ddb8a0c0c);

var $1ybV0 = parcelRequire("1ybV0");
const $2d3550a09830cc5e$var$globalObj = window || $parcel$global;
const $2d3550a09830cc5e$var$defaultHealthcheck = (callback)=>callback({
        isSuccess: true
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2d3550a09830cc5e$var$failingHealthcheck = (callback)=>callback({
        isSuccess: false
    });
const $2d3550a09830cc5e$export$90dcee7ddb8a0c0c = (healthcheck = $2d3550a09830cc5e$var$defaultHealthcheck)=>{
    const isHealthcheckAllFailEnabled = (0, $1ybV0.ff)('fe.platform.healthcheck.allfail.enabled');
    if (isHealthcheckAllFailEnabled) {
        $2d3550a09830cc5e$var$globalObj.performHealthcheck = $2d3550a09830cc5e$var$failingHealthcheck;
        return;
    }
    $2d3550a09830cc5e$var$globalObj.performHealthcheck = healthcheck;
};

});

parcelRegister("bAQOb", function(module, exports) {

$parcel$export(module.exports, "componentWithFF", () => $a2b6ad64f224d7cd$export$377d327ec8da8be);

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");
const $a2b6ad64f224d7cd$export$377d327ec8da8be = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)(featureFlagName), ComponentTrue, ComponentFalse);

});



//# sourceMappingURL=async-heartbeat.7e493517.js.map
